import { render } from "./TableInfo.vue?vue&type=template&id=0ce84534&ts=true"
import script from "./TableInfo.vue?vue&type=script&lang=ts"
export * from "./TableInfo.vue?vue&type=script&lang=ts"

import "./TableInfo.vue?vue&type=style&index=0&id=0ce84534&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__